// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1mPqe_P6OpF5jO1MyxUSZd"};